const hexToRGB = (hex: string): number[] => {
  hex = hex.replace("#", "");

  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((char) => char + char)
      .join("");
  }

  return [
    parseInt(hex.substring(0, 2), 16), // R
    parseInt(hex.substring(2, 4), 16), // G
    parseInt(hex.substring(4, 6), 16), // B
  ];
};

const parseRGBA = (rgba: string): number[] => {
  const match = rgba.match(/\d+(\.\d+)?/g);
  if (!match) return [0, 0, 0, 1];
  return match.map(Number);
};

const calculateLuminance = (r: number, g: number, b: number): number => {
  const [rs, gs, bs] = [r, g, b].map((val) => {
    val = val / 255;
    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
  });

  return 0.2126 * rs + 0.7152 * gs + 0.0722 * bs;
};

export const isBrightColor = (color: string, threshold = 0.5): boolean => {
  let rgb: number[];

  if (color.startsWith("#")) {
    rgb = hexToRGB(color);
  } else if (color.startsWith("rgb")) {
    rgb = parseRGBA(color);
  } else {
    console.log("Invalid color format. Use hex or rgba.");
    return true;
  }

  const luminance = calculateLuminance(rgb[0], rgb[1], rgb[2]);
  return luminance > threshold;
};
